<script>
    // core components
    import UsuarioView from "../../viewsERP/Usuario.svelte";
  </script>
  
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <UsuarioView />
    </div>
  </div>